import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/shopify.constant";

export {
    addShopifyProductPriceSyncs,
    addSingleShopifyProductPriceSync,
    updateSingleShopifyProductPriceSync,
    getSingleShopifyProductPriceSync,
    getAllShopifyProductPriceSyncs,
    searchShopifyProductPriceSyncs,
    searchShopifyProductPriceSyncsWithSearchCriteria,
    prepareShopifyProductPriceSyncsList
}

const collectionName = 'shopify-product-price-syncs';
const collectionReference = collection(fireStoreDB, collectionName);

const addShopifyProductPriceSyncs = (shopifyProductPriceSyncs) => {
    return Promise.map(shopifyProductPriceSyncs, async shopifyProductPriceSync => {
        await addSingleShopifyProductPriceSync(shopifyProductPriceSync);
    });
}

const addSingleShopifyProductPriceSync = (shopifyProductPriceSync) => {
    shopifyProductPriceSync.createdAt = new Date();
    shopifyProductPriceSync.updatedAt = shopifyProductPriceSync.createdAt;
    return addDoc(collectionReference, shopifyProductPriceSync);
}

const updateSingleShopifyProductPriceSync = (shopifyProductPriceSync) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyProductPriceSync.id);
    shopifyProductPriceSync.updatedAt = new Date();
    return setDoc(documentReference, shopifyProductPriceSync);
}

const getSingleShopifyProductPriceSync = async (shopifyProductPriceSyncId) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyProductPriceSyncId);
    const shopifyProductPriceSyncDoc = await getDoc(documentReference);
    return prepareSingleShopifyProductPriceSync(shopifyProductPriceSyncDoc);
}

const getAllShopifyProductPriceSyncs = async () => {
    let searchQuery = query(collectionReference);
    const shopifyProductPriceSyncsResult = await getDocs(searchQuery);
    return prepareShopifyProductPriceSyncsList(shopifyProductPriceSyncsResult);
}

const searchShopifyProductPriceSyncs = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const shopifyProductPriceSyncResult = await getDocs(searchQuery);
    return prepareShopifyProductPriceSyncsList(shopifyProductPriceSyncResult);
}

const searchShopifyProductPriceSyncsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchShopifyProductPriceSyncsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    searchQuery = query(searchQuery, limit(perPage));

    const shopifyProductPriceSyncResult = await getDocs(searchQuery);
    return prepareShopifyProductPriceSyncsList(shopifyProductPriceSyncResult);
}

const prepareShopifyProductPriceSyncsList = (shopifyProductPriceSyncResult) => {
    const shopifyProductPriceSyncsList = [];

    _.forEach(shopifyProductPriceSyncResult.docs, shopifyProductPriceSyncDoc => {
        shopifyProductPriceSyncsList.push(prepareSingleShopifyProductPriceSync(shopifyProductPriceSyncDoc));
    });

    return shopifyProductPriceSyncsList;
}


const prepareSingleShopifyProductPriceSync = (shopifyProductPriceSyncDoc) => {
    const shopifyProductPriceSync = shopifyProductPriceSyncDoc.data();
    shopifyProductPriceSync.id = shopifyProductPriceSyncDoc.id;
    return shopifyProductPriceSync;
}
